export const CAMPAIGN_TABS = {
  available: 'available',
  joined: 'joined',
};

export const STATUS_BADGE = {
  ONGOING: 'Devam Ediyor',
  ENDING_SOON: 'Bitmek Üzere',
  ENDING: 'Bitmesine Az Kaldı',
  UPCOMING: 'Yaklaşan Kampanya',
  UPCOMING_SOON: 'Çok Yakında Başlıyor',
};

export const STATUS = {
  ONGOING: 'ONGOING',
  ENDING_SOON: 'ENDING_SOON',
  ENDING: 'ENDING',
  UPCOMING: 'UPCOMING',
  UPCOMING_SOON: 'UPCOMING_SOON',
};

export const RETURN_STATUS = {
  ONGOING: 'status-ongoing',
  ENDING: 'status-ending',
  UPCOMING: 'status-upcoming',
};
